module.exports = import("https://rambaut.github.io/figtree.js/dist/figtree.esm.js");;